module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NCA2NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+U2hhcGUgQ29weSA3PC90aXRsZT48cGF0aCBkPSJNMjAuMTE1IDFINDMuODNsLjA0MiA0MC44M0g2NEwzMiA2NSAwIDQxLjgzaDIwLjE1N3oiIHN0cm9rZT0iIzIxMjEyMSIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ../src/images/arrow-big.svg
// module id = 789
// module chunks = 0